import { keysIn as r } from "./keysIn.js";
import { eq as e } from "../util/eq.js";
function p(i) {
  for (var t = 0; t < (arguments.length <= 1 ? 0 : arguments.length - 1); t++) l(i, t + 1 < 1 || arguments.length <= t + 1 ? undefined : arguments[t + 1]);
  return i;
}
function l(i, n) {
  var t = r(n);
  for (var o = 0; o < t.length; o++) {
    var f = t[o];
    e(i[f], n[f]) || (i[f] = n[f]);
  }
}
export { p as assignIn };